/**
 * Player DOM selector registry — centralizes all element IDs used by the
 * media player UI layer. Extracting these from inline string literals:
 *  1. Makes the player portable — a host app can override IDs via a
 *     custom selector config instead of editing 10+ source files.
 *  2. Prevents typo drift — a misspelled ID fails loudly at the single
 *     source of truth instead of silently returning null at a call site.
 *  3. Documents the player's DOM contract in one place.
 *
 * Usage:
 *   import { playerSelectors } from "./mediaPlayerSelectors";
 *   const playIcon = doc.getElementById(playerSelectors.audio.playIcon);
 */

export interface PlayerSelectorConfig {
	/** Audio player bar elements */
	audio: {
		playIcon: string;
		progress: string;
		progressSlider: string;
		time: string;
		speedBtn: string;
	};
	/** Video fullscreen player elements */
	video: {
		container: string;
		progressFill: string;
		progress: string;
		time: string;
		playToggleIcon: string;
		replay: string;
		chapterTitle: string;
		chapterLabel: string;
		topicName: string;
		chapterDesc: string;
		chapterDots: string;
	};
}

export const playerSelectors: PlayerSelectorConfig = {
	audio: {
		playIcon: "playIcon",
		progress: "playerProgress",
		progressSlider: "audioProgressSlider",
		time: "audioTime",
		speedBtn: "audioSpeedBtn",
	},
	video: {
		container: "videoFullscreen",
		progressFill: "vfProgressFill",
		progress: "vfProgress",
		time: "vfTime",
		playToggleIcon: "vfPlayToggleIcon",
		replay: "vfReplay",
		chapterTitle: "vfChapterTitle",
		chapterLabel: "vfChapterLabel",
		topicName: "vfTopicName",
		chapterDesc: "vfChapterDesc",
		chapterDots: "vfChapterDots",
	},
};
